import { render, staticRenderFns } from "./writeNewPassword.vue?vue&type=template&id=5ea12bdb&scoped=true"
import script from "./writeNewPassword.vue?vue&type=script&lang=js"
export * from "./writeNewPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea12bdb",
  null
  
)

export default component.exports